import pptxgen from "pptxgenjs";

export const exportGoldPPTX = async (topic, age, data) => {
    let pres = new pptxgen();

    // Diapositiva 1: Título Principal
    let slideTitle = pres.addSlide();
    slideTitle.background = { color: "0B1120" }; // Azul muy oscuro (estilo DinamiClass)
    slideTitle.addText(data.titulo_presentacion || `Presentación: ${topic}`, {
        x: 1, y: 2, w: 8, h: 1.5,
        fontSize: 36, bold: true, color: "FFFFFF", align: "center"
    });
    slideTitle.addText(`Material para alumnos de ${age} años`, {
        x: 1, y: 3.5, w: 8, h: 1,
        fontSize: 18, color: "94A3B8", align: "center"
    });

    // Diapositivas de contenido
    if (data.diapositivas && data.diapositivas.length > 0) {
        data.diapositivas.forEach(diapo => {
            let slide = pres.addSlide();
            slide.background = { color: "0F172A" }; // Fondo oscuro

            // Título de la diapositiva
            slide.addText(diapo.titulo, {
                x: 0.5, y: 0.5, w: 9, h: 1,
                fontSize: 28, bold: true, color: "3B82F6" // Título en Azul
            });

            // Viñetas
            if (diapo.vinetas && diapo.vinetas.length > 0) {
                let bullets = diapo.vinetas.map(v => ({ text: v, options: { bullet: true } }));
                slide.addText(bullets, {
                    x: 0.5, y: 1.8, w: 9, h: 3.5,
                    fontSize: 20, color: "E2E8F0", lineSpacing: 30, valign: "top"
                });
            }
        });
    }

    // Descargar el archivo
    await pres.writeFile({ fileName: `Presentacion_${topic.replace(/\s+/g, '_')}.pptx` });
};
